module.exports = __webpack_public_path__ + "static/js/scheduledMailMerges.36b86a47.chunk.worker.js"